import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/Navbar";
import { API } from "../context/AuthContext";
import { XCircle, AlertTriangle } from "lucide-react";
import { trackFunnel } from "../lib/track";

const eur = (c) => `€${((c || 0) / 100).toFixed(2)}`;

export default function PaymentCancel() {
  const nav = useNavigate(); const [params] = useSearchParams();
  const oid = params.get("order_id"); const failed = params.get("failed") === "1";
  const [order, setOrder] = useState(null); const [loaded, setLoaded] = useState(!oid);
  useEffect(() => {
    trackFunnel("checkout_abandoned", { failed });
    if (!oid) return;
    axios.get(`${API}/payments/order/${oid}`).then(async ({ data }) => {
      setOrder(data);
      if (!failed && ["CREATED", "PENDING"].includes(data.status)) await axios.post(`${API}/payments/order/${oid}/cancel`).catch(() => {});
    }).catch(() => {}).finally(() => setLoaded(true));
  }, [oid]);
  const retry = order?.retry_url || "/pricing"; const isFail = failed || order?.status === "FAILED";
  return (
    <div className="min-h-screen grain-bg">
      <Navbar variant="pro" />
      <div className="pt-28 pb-24 max-w-2xl mx-auto px-5 text-center">
        <div className="rl-card p-8 md:p-12" data-testid={isFail ? "payment-failed" : "payment-cancelled"}>
          {isFail ? <AlertTriangle className="w-16 h-16 text-[#FF9F0A] mx-auto mb-4" /> : <XCircle className="w-16 h-16 text-[#FF1E27] mx-auto mb-4" />}
          <h1 className="font-display font-black text-3xl mb-3" data-testid="cancel-heading">{isFail ? "Pagamento non riuscito" : "Pagamento annullato"}</h1>
          <p className="text-slate-400 mb-6">{isFail ? "Non è stato possibile completare il pagamento. Controlla il metodo scelto o riprova." : "Pagamento annullato. Nessun importo è stato addebitato."}</p>
          {order && <div className="rl-card p-4 text-left text-sm mb-6" data-testid="cancel-summary">
            <div className="flex justify-between border-b border-white/5 py-1.5"><span className="text-slate-400">Piano</span><span>{order.plan_name || order.plan_code}</span></div>
            {order.rally_name && <div className="flex justify-between border-b border-white/5 py-1.5"><span className="text-slate-400">Rally</span><span>{order.rally_name}</span></div>}
            {order.coupon_code && <div className="flex justify-between border-b border-white/5 py-1.5"><span className="text-slate-400">Codice sconto</span><span>{order.coupon_code} (conservato)</span></div>}
            <div className="flex justify-between py-1.5"><span className="text-slate-400">Totale previsto</span><span className="font-display font-bold">{eur(order.total_cents)} IVA inclusa</span></div>
          </div>}
          {!order && oid && loaded && <div className="rl-card p-4 text-sm text-slate-400 mb-6" data-testid="cancel-summary">Ordine non più disponibile: puoi comunque ripartire dai piani.</div>}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button className="btn-crimson min-h-[48px]" onClick={() => nav(retry)} data-testid="retry-payment-btn">RIPROVA</button>
            <button className="btn-outline-rl min-h-[48px]" onClick={() => nav(retry)} data-testid="other-method-btn">SCEGLI ALTRO METODO</button>
            <button className="btn-outline-rl min-h-[48px]" onClick={() => nav("/pricing")} data-testid="back-to-pricing">TORNA AI PIANI</button>
          </div>
          <p className="text-xs text-slate-500 mt-6">Piano, rally e codice sconto restano salvati: puoi riprendere da dove avevi lasciato.</p>
        </div>
      </div>
    </div>
  );
}
